// src/components/SessionTimer.js
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const SessionTimer = () => {
    const [timeLeft, setTimeLeft] = useState(0);
    const navigate = useNavigate();
    const token = localStorage.getItem('token');

    // Function to handle logout
    const handleLogout = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('userEmail'); // Also clear email if stored
        navigate('/login');
    };

    // Effect to initialize timer based on token expiry
    useEffect(() => {
        if (token) {
            try {
                const decodedToken = JSON.parse(atob(token.split('.')[1]));
                const currentTime = Math.floor(Date.now() / 1000);
                const tokenTimeLeft = decodedToken.exp - currentTime;

                if (tokenTimeLeft > 0) {
                    setTimeLeft(tokenTimeLeft);
                } else {
                    // Token already expired when component mounted
                    handleLogout();
                }
            } catch (error) {
                console.error("Error decoding token:", error);
                setTimeLeft(0);
                // Optionally logout if token is invalid
                handleLogout();
            }
        } else {
            setTimeLeft(0); // No token, no time left
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]); // Dependency: only re-run if the token itself changes

    // Effect to decrement the timer or logout when it hits zero
    useEffect(() => {

        const timer = setTimeout(() => {
            setTimeLeft(timeLeft - 1);
        }, 1000);


        return () => clearTimeout(timer);

    }, [timeLeft, token]); // Dependencies: run when timeLeft changes or token status changes

    // Determine flashing state (e.g., flash for the last 60 seconds)
    const isFlashing = timeLeft > 0 && timeLeft <= 60;

    // Don't render anything if the timer hasn't been initialized or is zero
    if (timeLeft <= 0) {
        return null; // Or potentially just the logout button if needed in some edge cases
    }

    // Render the Logout button and the timer display
    return (
        <>
            <Button color="inherit" onClick={handleLogout} sx={{ fontFamily: 'Comfortaa, sans-serif', marginRight: '1rem' }}>
                Logout
            </Button>
            <Box
                sx={{
                    color: 'white',
                    padding: '8px 16px',
                    borderRadius: '4px',
                    fontFamily: 'Comfortaa, sans-serif',
                    // Apply flashing animation if needed
                    animation: isFlashing ? 'flash 1s linear infinite' : 'none',
                    '@keyframes flash': {
                        '0%': { backgroundColor: 'rgba(255, 0, 0, 0.7)' }, // Use rgba for subtle flash
                        '50%': { backgroundColor: 'transparent' },
                        '100%': { backgroundColor: 'rgba(255, 0, 0, 0.7)' },
                    },
                }}
            >
                <Typography variant="body1" sx={{ fontFamily: 'Comfortaa, sans-serif'}}>
                    Session expires in: {Math.floor(timeLeft / 60)}:{timeLeft % 60 < 10 ? `0${timeLeft % 60}` : timeLeft % 60}
                </Typography>
            </Box>
        </>
    );
};

export default SessionTimer;
